/* tslint:disable:prefer-for-of */
import {UIFormEngineComponentMetadata} from './ui/form';
import {I18N} from './ui/helper/I18N';

export class Chunker {

	public pagination: ChunkerPagination = new ChunkerPagination(0, 0);

	protected data;
	protected dataOriginal;
	public size = 0;

	public constructor(data) {
		this.data = data;
		this.dataOriginal = this.data;
		this.size = data.length;
		this.pagination = ChunkerPagination.Calculate(data, this.size);
	}

	public getOriginalData() {
		return this.dataOriginal;
	}

	public applySort(by: ChunkerFilter, direction) {
		console.log('chunker.applySort', {by, direction});
		// sort this.data
		this.data.sort((a: any, b: any) => {
			// console.log('sort', a, b);
			let from = a[by.id];
			let to = b[by.id];
			if (by.idFunction) {
				from = by.idFunction(a);
				to = by.idFunction(b);
			}
			// null end up at the end
			if (from == null) {
				return 1;
			}
			if (to == null) {
				return -1;
			}
			// console.log('sort', from, to, by);
			switch (by.sortable) {
				case 'number':
					if (from === .0000 || from === null) {
						from = 0;
					}
					if (to === .0000 || to === null) {
						to = 0;
					}
					from = parseInt(from, 0);
					to = parseInt(to, 0);
					break;
				case 'date':
					from = parseInt(from.replace(/-/g, ''), 0);
					to = parseInt(to.replace(/-/g, ''), 0);
					console.log(from, to, from < to);
					break;
				default:
					from = from.toUpperCase ? from.toUpperCase() : from;
					to = to.toUpperCase ? to.toUpperCase() : to;
			}
			const ret = direction === 'dsc' ? from < to : from > to;
			// console.log(from, to, ret);
			return ret ? 1 : -1;
		});
		// console.log('chunker.applySort', this.data);

		//   console.log('order',this.data);
	}

	public applyFilters(filters: ChunkerFilter[]) {
		let hasFilters = false;
		for (const f of filters) {
			if (f.filterable && f.filterValue) {
				hasFilters = true;
			}
		}
		console.log('chunker.applyFilters', hasFilters);
		if (hasFilters) {
			this.data = [];
			//	console.log(this.dataOriginal);
			for (let i = 0; i < this.dataOriginal.length; i++) {
				let filteredOut = false;
				if (this.dataOriginal[i]) {
					for (const f of filters) {
						if (f.filterable && f.filterValue) {
							let from = f.filterValue;
							const to = f.idFunction != null ? f.idFunction.call(f, this.dataOriginal[i], f.id, f.filterValue) : this.dataOriginal[i][f.id];
							if (to === null || to === '') {
								filteredOut = true;
							} else if (typeof to === 'number') {
								// special operators
								if (from.length > 0 && (from.substring(0, 1) == '<' || from.substring(0, 1) == '>')) {
									const op = from.substring(0, 1);
									switch (op) {
										case '>':
											from = from.substring(1);
											if (Number(from) >= to) {
												filteredOut = true;
											}
											break;
										case '<':
											from = from.substring(1);
											if (Number(from) <= to) {
												filteredOut = true;
											}
											break;
									}
								} else if (Number(from) !== to) {
									console.log(from, to, Number(from) !== to);
									filteredOut = true;
								}
							} else {
								let whichCase = f.type;
								if (f.exactMatch === false) {
									whichCase = 'willGoToDefaultSwitchCase';
								}
								switch (whichCase) {
									case 'date':
										// console.log({from, to, sub: to ? to.substring : null});
										if (!from || !to || !to.substring || from !== to.substring(0, '2019-01-01'.length)) {
											filteredOut = true;
										}
										break;
									case 'bool':
									case 'dropdown':
										if (from !== to) {
											filteredOut = true;
										}
										break;
									default:
										const filteredValue = I18N.removeDiacritics(from).toLowerCase();
										let valueToCheck = I18N.removeDiacritics(to);
										if (valueToCheck) {
											if (valueToCheck.toLowerCase) {
												valueToCheck = valueToCheck.toLowerCase();
											}
											if (valueToCheck.indexOf(filteredValue) === -1) {
												filteredOut = true;
											}
										}
								}
							}
						}
					}
				}
				if (!filteredOut) {
					this.data.push(this.dataOriginal[i]);
				}
			}
		} else {
			this.data = this.dataOriginal;
		}
		this.pagination.total = this.data.length;
		this.pagination.recalculate();

	}

	extractData() {
		const ret = [];

		const starts = (this.pagination.currentPage - 1) * this.pagination.size;
		const ends = (this.pagination.currentPage) * this.pagination.size;

		// console.log('chunker.extractData', {currentPage: this.pagination.currentPage, starts, ends, size: this.pagination.size});
		for (let i = starts; i < ends; i++) {
			if (this.data[i]) {
				ret.push(this.data[i]);
			}
		}
		// console.log('chunker.extractData', 'Done');
		return ret;
	}
}

export class ChunkerFilter extends UIFormEngineComponentMetadata {
	public filterValue?;
	public filterable ? = false;
	public exactMatch ? = false;
	public sortable ? = 'default';

}

export class ChunkerPagination {
	public size = 10; // default
	public displayOnlyXPages = 4; // + arrows + current
	public totalPages = 0;
	public total = 0;
	public fullResultsCount = 0;
	public currentPage = 1;
	public hasNextPage = false;
	public hasPreviousPage = false;
	public hasLastPage = false;
	public hasFirstPage = false;
	public pages = [];

	public static Calculate(data, fullResultsCount): ChunkerPagination {
		return new ChunkerPagination(data.length, fullResultsCount);
	}

	public constructor(total, fullResultsCount) {
		this.total = total;
		this.fullResultsCount = fullResultsCount;
		this.recalculate();
	}

	public next() {
		if (this.hasNextPage) {
			this.currentPage++;
			this.recalculate();
		}
	}

	public prev() {
		if (this.hasPreviousPage) {
			this.currentPage--;
			this.recalculate();
		}
	}

	public goToPage(p) {
		// console.log('chunker.pagination.goToPage(' + p + ')');
		if (p > 0 && p <= this.totalPages) {
			this.currentPage = p;
			this.recalculate();
		}
	}

	public recalculate() {
		// reset
		this.pages = [];
		this.hasFirstPage = false;
		this.hasLastPage = false;
		this.hasNextPage = false;
		this.hasPreviousPage = false;


		// do
		this.totalPages = Math.ceil(this.total / this.size);

		// console.log('rec', this.totalPages);

		if (this.totalPages > 1) {
			const pages = [];
			const halfOfPagesToDisplay = this.displayOnlyXPages / 2;

			let index = this.currentPage - halfOfPagesToDisplay - 1;
			if (index < 0) {
				index = 0;
			}
			let count = 0;
			do {
				index++;
				count++;
				pages.push(new ChunkerPaginationPage(index, index <= this.totalPages ? index : '', index === this.currentPage, index <= this.totalPages && this.totalPages > 1));
			} while (count < this.displayOnlyXPages + 1);

			if (this.currentPage > 1) {
				this.hasFirstPage = true;
				this.hasPreviousPage = true;
			}
			if (this.currentPage < this.totalPages) {
				this.hasNextPage = true;
				this.hasLastPage = true;
			}
			this.pages.push(new ChunkerPaginationPage(1, '<<', this.currentPage == 1, this.currentPage > 1 && this.totalPages > 1));
			// this.pages.push(new ChunkerPaginationPage(this.currentPage - 1, '<', false, this.currentPage > 1));
			for (const p of pages) {
				this.pages.push(p);
			}
			// this.pages.push(new ChunkerPaginationPage(this.currentPage + 1, '>', false, this.currentPage != this.totalPages ));
			this.pages.push(new ChunkerPaginationPage(this.totalPages, '>>', false, this.currentPage != this.totalPages));

		}

//        console.log('chunk pagination recalculate', this);
	}

}

export class ChunkerPaginationPage {
	public index;
	public name;
	public active = true;
	public isCurrent = false;

	public constructor(index, name, isCurrent, active) {
		this.index = index;
		this.name = name;
		this.isCurrent = isCurrent;
		this.active = active;
	}
}
